import React from 'react'

const ResendIcon = ({ bgColor }) => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_484_384)">
                <path d="M7.32317 1.92394C7.32317 0.508777 9.01952 -0.216058 10.0422 0.76213L20.08 10.3634C20.7239 10.9793 20.7441 12.0014 20.125 12.6422L10.0872 23.0331C9.08271 24.0729 7.32317 23.3618 7.32317 21.916L7.32317 1.92394Z" fill={bgColor} />
            </g>
            <defs>
                <clipPath id="clip0_484_384">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default ResendIcon